import { computed } from 'vue';
import type { Sort } from '../index';
import useLocale from './../composables/useLocale';

export type SortOption = {
  key: string;
  label: string;
  icon: string;
  sort?: Sort;
};

export type SortKey = 'default' | 'lastAdded' | 'titleAsc' | 'titleDesc' | 'authorAsc' | 'authorDesc';

const useSortOptions = (fields?: string[]) => {
  const { t } = useLocale();
  return computed<SortOption[]>(() => {
    const defaultFields = [
      {
        key: 'default',
        label: t('content_search.search.sort.none'),
        icon: 'mdi-sort',
        sort: undefined,
      },
      {
        key: 'lastAdded',
        label: t('content_search.search.sort.lastAdded'),
        icon: 'mdi-sort-clock-ascending-outline',
        sort: {
          field: 'createdAt',
          order: 'desc',
        },
      },
      {
        key: 'titleAsc',
        label: t('content_search.search.sort.titleAsc'),
        icon: 'mdi-sort-alphabetical-ascending',
        sort: {
          field: 'title',
          order: 'asc',
        },
      },
      {
        key: 'titleDesc',
        label: t('content_search.search.sort.titleDesc'),
        icon: 'mdi-sort-alphabetical-descending',
        sort: {
          field: 'title',
          order: 'desc',
        },
      },
      {
        key: 'authorAsc',
        label: t('content_search.search.sort.authorAsc'),
        icon: 'mdi-account-arrow-down-outline',
        sort: {
          field: 'authors.fullName',
          order: 'asc',
        },
      },
      {
        key: 'authorDesc',
        label: t('content_search.search.sort.authorDesc'),
        icon: 'mdi-account-arrow-up-outline',
        sort: {
          field: 'authors.fullName',
          order: 'desc',
        },
      },
    ];
    if (!fields) {
      return defaultFields as SortOption[];
    }
    return defaultFields.filter((option) => fields.includes(option.key)) as SortOption[];
  });
};

export default useSortOptions;
